import { render, staticRenderFns } from "./HelpCenterCategoriesEdit.vue?vue&type=template&id=e3cc9690&"
import script from "./HelpCenterCategoriesEdit.vue?vue&type=script&lang=js&"
export * from "./HelpCenterCategoriesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports